import { supabase } from '../supabaseClient';

/**
 * Plan v9/A2: saldo, z którego faktycznie zapłaci zalogowany użytkownik.
 * Członek organizacji → pula organizacji (organizations.credits); plan 'mediafy' → bez limitu (Infinity).
 * Konto bez organizacji → credits per użytkownik (jak dotąd).
 * Fallback na tabelę `credits`, gdy RPC `my_credits` jeszcze nie istnieje (prod przed migracją).
 */
export async function fetchMyCredits(userId) {
  try {
    const { data, error } = await supabase.rpc('my_credits');
    if (!error && data) {
      return {
        balance: data.unlimited ? Infinity : Number(data.balance ?? 0),
        scope: data.scope,
        orgName: data.org_name ?? null,
        unlimited: !!data.unlimited,
      };
    }
  } catch { /* brak RPC → fallback */ }
  const { data: cred } = await supabase.from('credits').select('balance').eq('user_id', userId).single();
  return { balance: cred?.balance ?? 0, scope: 'user', orgName: null, unlimited: false };
}
